<div class="dialog dialog-small dialog-flex-direction-column">
    <h4 class="dialog-inner h4-blue">Professional Liability Premium Benefit</h4>
    <div class="dialog-inner">The Professional Liability Insurance Premium benefit reimburses the insured or their
        employer for professional liability insurance premiums (malpractice insurance) after becoming disabled.
        Professional liability coverage must have been active at the onset of disability, and payments are made directly
        to the liability carrier.</div>
    <div class="dialog-inner semibold">Additional Annual Cost</div>
   <div class="cost">{{cost ? (cost | currency) : 'Calculating...'}}</div>
    <!--
    <br />
    <mat-label class="label-text">Monthly Contribution Amount</mat-label>
    -->
    <br />
    <mat-form-field>
        <mat-label class="label-text">Monthly Amount</mat-label>
        <mat-select [(ngModel)]="PLPAmount" [disabled]="PLPAmountOptions.length <= 0" (selectionChange)="updateCost()">
            <mat-option *ngIf="PLPAmountOptions.length <= 0" value="{{PLPAmount}}">${{PLPAmount}}</mat-option>
            @for ( item of PLPAmountOptions; track item ) {
            <mat-option value="{{item}}">${{item}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <!--
    <mat-label class="label-text semibold">Maximum Benefit Duration</mat-label>
    <br />
    -->
    <mat-form-field>
        <mat-label class="label-text">Maximum Duration</mat-label>
        <mat-select [(ngModel)]="PLPDuration" [disabled]="PLPDurationOptions.length <= 1"
            (selectionChange)="updateCost()">
            <mat-option *ngIf="PLPDurationOptions.length <= 1" value="{{PLPDuration}}">{{PLPDuration}}</mat-option>
            @for ( item of PLPDurationOptions; track item ) {
            <mat-option value="{{item}}">{{item}}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    <!--<div class="dialog-inner">Would you like to add this benefit to your policy?</div> -->
    <div *ngIf="!inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="no()" class="chat-button chat-button-define" mat-flat-button>Cancel</button>
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Add to Policy</button>

    </div>
    <div *ngIf="inclusion()" class="dialog-inner-buttons">
        <button class="button-mgis" (click)="yes()" class="chat-button chat-button-define" mat-flat-button>Close</button>
    </div>
    <br/>